var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatBubble = function SvgChatBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 1h-7A2.5 2.5 0 0 0 1 3.5V7a2.5 2.5 0 0 0 2.5 2.5h1l2.5 3 2.5-3h1A2.5 2.5 0 0 0 13 7V3.5A2.5 2.5 0 0 0 10.5 1M4.5 4.5h5M4.5 6.5H8"
  })));
};
export default SvgChatBubble;